import { render, staticRenderFns } from "./_incomeStatement.vue?vue&type=template&id=393c2bb6&scoped=true&"
import script from "./_incomeStatement.vue?vue&type=script&lang=js&"
export * from "./_incomeStatement.vue?vue&type=script&lang=js&"
import style0 from "./_incomeStatement.vue?vue&type=style&index=0&id=393c2bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c2bb6",
  null
  
)

export default component.exports